import "../../shared/components/wizard_modal.js";
import "../../utilities/recaptcha.js";
import "../../shared/components/sparkle_loader.js";
import "./form_modal/form_modal_review.js";
import "../../shared/utilities/form_validation.js";

// Assigned to window as a class expression (not a declaration plus a later
// `window.FormModal = FormModal`): rolldown's tree-shaker drops the
// declaration/assignment pair as unused, leaving only the bare heritage
// expression `WizardModal;` behind, which throws at module eval in
// production chunks. A direct window assignment is not shakeable.
window.FormModal = class FormModal extends WizardModal {
  constructor(formElement, options) {
    var modalOptions = jQuery.extend(
      {
        class: "form-modal",
        completeText: "Submit",
      },
      options,
    );

    super(modalOptions);

    this.title = options.title;
    this.form = formElement;
    this._setContent(formElement);
    this.form.data("unsubmitted", true);
    this.errorMessageAdded = false;
    this.validator = new FormValidation();
    this.formReview = new FormModalReview({ event: this.options.event });
    // Because the form modal rips the form fields out of the form
    // We need to handle the recaptcha inside the form modal itself
    this.recaptchaEnabled = this.form.data("recaptcha");

    // BEHAVIOUR
    window.addEventListener("unload", this.handleUnload.bind(this));

    this.form.on("submit", this.handleSubmit.bind(this));
    this.form.on("ajax:success", this.handleFormAjaxSuccess.bind(this));
    this.form.on("ajax:error", this.handleFormAjaxError.bind(this));

    this.modal.container.on("blur", "input", this.handleInputChanged.bind(this));
    this.modal.container.on("beforeShow", this.handleBeforeShow.bind(this));
    this.modal.container.on("beforeHide", this.handleBeforeHide.bind(this));
    this.modal.container.on("beforePageShow", this.handleBeforePageShow.bind(this));
    this.modal.container.on("pageShow", this.handlePageShow.bind(this));
    this.modal.container.on("sessions:time-slot-selected", this.handleSessionsTimeSlotSelection.bind(this));
    this.modal.container.on("beforeComplete", this.handleBeforeComplete.bind(this));
  }

  // EVENT HANDLERS

  handleUnload(event) {
    this._resetForm();
    this.modal.hide();
  }

  handleSubmit() {
    this.form.data("unsubmitted", false);
  }

  handleFormAjaxSuccess(event, response) {
    const content = jQuery("<div>").html(response).find("article");
    let title = content.find("h1");
    if (title) {
      title = title.remove().text();
    }
    title = title || "Thank You";

    this._updateSubmitPage(title, content, "Close");
  }

  handleFormAjaxError(event, transport) {
    const title = "Problem Submitting Form";
    const content = jQuery("<div>");
    content.append("<h3 class='form-modal-title--error'>Oops, something went wrong!</h3>");
    content.append("<p>Looks like there was an error in submitting your form, please try again!</p>");

    this._updateSubmitPage(title, content, "Close");
  }

  handleBeforeShow(event) {
    if (this.recaptchaEnabled) {
      Sparkle.Recaptcha.startSession();
    }
  }

  handleBeforeHide(event) {
    if (this.recaptchaEnabled) {
      Sparkle.Recaptcha.endSession();
    }
  }

  handleBeforePageShow(e, page) {
    if (page === this.confirmationPage) {
      this._renderFormReview();
    }

    if (page === this.submitPage) {
      this._renderSubmitPage();
    }
  }

  handlePageShow(event, page) {
    this.currentPage = page;
    this._updateStateForNextButton();
  }

  handleInputChanged(event) {
    var input = event.currentTarget;
    this.validator.addValidityMessage(input);
    this._updateStateForNextButton();
  }

  handleSessionsTimeSlotSelection(event, timeButton) {
    var modelBody = this.getPage(this.pageNumber).content.find(".modal-body");
    var selectedProviderList = timeButton.closest(".session-slot-selector").find(".provider-list.selected");

    modelBody.animate(
      {
        scrollTop:
          jQuery(selectedProviderList).offset().top -
          jQuery(modelBody).offset().top +
          jQuery(modelBody).prop("scrollTop"),
      },
      500,
    );
  }

  handleBeforeComplete() {
    if (this.form.data("unsubmitted")) {
      this.abortCompletion();
      this.prepareDataForSubmission().then(() => this.form.submit());
    } else {
      this._resetForm();
    }
  }

  prepareDataForSubmission() {
    var deferred = new jQuery.Deferred();

    if (this.recaptchaEnabled) {
      Sparkle.Recaptcha.endSession().then((recaptchaValidationToken) => {
        this.form.append(
          jQuery("<input>").attr({ type: "hidden", name: "g-recaptcha-response", value: recaptchaValidationToken }),
        );
        deferred.resolve(this.form);
      });
    } else {
      deferred.resolve(this.form);
    }

    return deferred.promise();
  }

  // PRIVATE
  _setContent(formElement) {
    if (this.options.prefixPageContent) {
      this.prefixPage = this.addPage({ header: this.title, body: this.options.prefixPageContent });
    }

    this._configurePages(formElement);

    if (this.options.review) {
      this.confirmationPage = this.addPage({ header: "Confirm Form" });
    }

    this.submitPage = this.addPage({ header: "Submitting Form" });
  }

  _configurePages(formElement) {
    var content = jQuery("<div>").append(jQuery(formElement).children());
    var formFields = content.find(".form-fields").detach();

    var preamble = jQuery('<div class="form-preamble">');
    if (this.options.prefixFormContent) {
      preamble.append(this.options.prefixFormContent); // Prepend text to the first set of form fields.
    }
    content.find("[type='submit']").remove(); // Remove submit button, its not needed here
    preamble.append(content); // Add the remaining content, hidden inputs etc

    formFields.find(".field-input-group").each(createPageOnGroupBreak.bind(this));

    function createPageOnGroupBreak(index, group) {
      var page = this.addPage({ header: this.title });

      if (index == 0) {
        group.prepend(preamble.get(0));
      }

      page.setBody(group);
    }
  }

  _resetForm() {
    this.formReview.resetReview();
    var formInputs = this.modal.container.find('input:not([type="hidden"]');

    jQuery(formInputs).each((i, input) => {
      jQuery(input).val("");
      this.validator.removeValidityMessage(input);
    });

    this._updateSubmitPage("Submitting Form", "", "Submitting");
    this.form.data("unsubmitted", true);
  }

  _renderSubmitPage() {
    this.sparkleLoader = this.sparkleLoader || new SparkleLoader().el;
    this._configureForm();
    var content = jQuery(this.sparkleLoader).append(this.form);
    this._updateSubmitPage("Submitting Form", content[0], "Submitting");
    this._complete(this.navigationElements.complete);
  }

  _updateSubmitPage(title, content, buttonText) {
    this.submitPage.setHeader(title);
    this.submitPage.setBody(content);

    this.navigationElements.complete.html(buttonText);
  }

  _renderFormReview() {
    this.formReview.resetReview();
    let formFields = this.modal.container.find(".form-fields");
    this.formReview.addReviewItem(formFields);

    this.confirmationPage.setBody(this.formReview.el);
  }

  _configureForm() {
    var formContents = this.formReview.cloneForm(this.modal.container.find(".field-input-group"));
    this.form.empty();
    this.form.append(formContents);
    this.form.hide();
  }

  _updateStateForNextButton() {
    var inputs = this.currentPage.modal.body.find('input:not([type="hidden"]');

    if (this.validator.willGroupValidate(inputs)) {
      this.enableNextPage();
    } else {
      this.disableNextPage();
    }
  }
};
